<form [formGroup]="threadGroupForm" autocomplete="off">
  <ng-container>
    <mat-table [dataSource]="defaultData">

      <ng-container matColumnDef="startThreadsCount">
        <mat-header-cell *matHeaderCellDef> Start Threads Count </mat-header-cell>
        <mat-cell *matCellDef="let element;">
          <mat-form-field floatLabel="never">
            <input style="width: 90%;" matInput placeholder="Start Threads" formControlName="startThreadsCount" min="1" type="number" required>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="initialDelay">
        <mat-header-cell *matHeaderCellDef> Initial Delay (sec) </mat-header-cell>
        <mat-cell *matCellDef="let element;">
          <mat-form-field floatLabel="never">
            <input style="width: 90%;" matInput placeholder="Initial Delay" formControlName="initialDelay" min="0" type="number" required>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="startupTime">
        <mat-header-cell *matHeaderCellDef> Ramp-Up Time (sec) </mat-header-cell>
        <mat-cell *matCellDef="let element;">
          <mat-form-field floatLabel="never">
            <input style="width: 90%;" matInput placeholder="Ramp-Up Time" formControlName="startupTime" min="0" type="number" required>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="holdLoadFor">
        <mat-header-cell *matHeaderCellDef> Duration (sec) </mat-header-cell>
        <mat-cell *matCellDef="let element;">
          <mat-form-field floatLabel="never">
            <input style="width: 90%;" matInput placeholder="Duration" formControlName="holdLoadFor" min="1" type="number" required>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="shutDownTime">
        <mat-header-cell *matHeaderCellDef> Ramp Down Time (sec) </mat-header-cell>
        <mat-cell *matCellDef="let element;">
          <mat-form-field floatLabel="never">
            <input style="width: 90%;" matInput placeholder="Ramp Down Time" formControlName="shutDownTime" min="0" type="number" required>
          </mat-form-field>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Action">
        <mat-header-cell *matHeaderCellDef> Action </mat-header-cell>
        <mat-cell *matCellDef="let element;">
          <i class="fas fa-plus-circle clickable create-icon" (click)="addToList()" ></i>
          <i class="fas fa-pen clickable update-icon" (click)="updateList()" *ngIf="isEditing"></i>
          <i class="fas fa-times clickable cancle-icon" (click)="cancelEditList()" *ngIf="isEditing"></i>
        </mat-cell>
      </ng-container>

      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
      <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    </mat-table>
  </ng-container>
</form>
<form >
  <ng-container>
    <mat-table [dataSource]="addedList">

      <ng-container matColumnDef="startThreadsCount">
        <mat-cell *matCellDef="let element;">
          <div> {{element.startThreadsCount}} </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="initialDelay">
        <mat-cell *matCellDef="let element;">
          <div> {{element.initialDelay}} </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="startupTime">
        <mat-cell *matCellDef="let element;">
          <div> {{element.startupTime}} </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="holdLoadFor">
        <mat-cell *matCellDef="let element;">
          <div> {{element.holdLoadFor}} </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="shutDownTime">
        <mat-cell *matCellDef="let element;">
          <div> {{element.shutDownTime}} </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="Action">
        <mat-cell *matCellDef="let element; let i = index;">
          <i class="fas fa-trash clickable delete-icon" (click)="deleteRow(i)"></i>
          <i class="fas fa-edit clickable edit-icon" (click)="editList(i)"></i>
          <i class="fas fa-copy clickable clone-icon" (click)="cloneList(i)"></i>
        </mat-cell>
      </ng-container>

      <mat-row *matRowDef="let row; columns: displayedColumns;"></mat-row>
    </mat-table>
  </ng-container>
</form>

<div class="modal-footer" style="border-top: none;">
  <button type="submit" class="btn btn-primary btn-sm" (click)="saveConfiguration()" *ngIf="!edited" [disabled]="addedList.length === 0"> Add Configuration </button>
  <button type="submit" class="btn btn-primary btn-sm" (click)="updateConfiguration()" *ngIf="edited"[disabled]="addedList.length === 0"> Update Configuration </button>
  <button class="btn btn-warning btn-sm" type="button" (click)="cancelThreadGroupCreation()">Cancel</button>
</div>